import { AssetLinkList, AssetLinkListItem } from './asset-link-list.js';
export const MUSIC_LINK_LIST_NAME = 'musicLinkList';
const MUSIC_LINK_LIST_ITEM_NAME = `${MUSIC_LINK_LIST_NAME}Item`;
const MUSIC_LINK_LIST_TAG_NAME = 'mb-music-link-list';
export const MusicLinkList = AssetLinkList.extend({
    name: MUSIC_LINK_LIST_NAME,
    content: `${MUSIC_LINK_LIST_ITEM_NAME}*`,
    addOptions() {
        return {
            tagName: MUSIC_LINK_LIST_TAG_NAME,
        };
    },
    addCommands() {
        return {
            setMusicLinkList: () => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    content: [
                        {
                            type: MUSIC_LINK_LIST_ITEM_NAME,
                            attrs: { link: '' },
                        },
                        {
                            type: MUSIC_LINK_LIST_ITEM_NAME,
                            attrs: { link: '' },
                        },
                    ],
                });
            },
        };
    },
});
export const MusicLinkListItem = AssetLinkListItem.extend({
    name: MUSIC_LINK_LIST_ITEM_NAME,
    group: MUSIC_LINK_LIST_NAME,
});
//# sourceMappingURL=music-link-list.js.map